<template>
  <div class="registHasOrgs">
    <div class="title">您已经在本系统注册，以下是您注册过的机构</div>
    <main>
      <div class="org-item" v-for="(item, index) in orgLists" :key="index">
        <img v-if="item.unitAttr === '8'" src="@/assets/image/type1.png" alt="" />
        <img v-else src="@/assets/image/type2.png" alt="" />
        <div class="van-ellipsis">{{ item.displayName }}</div>
      </div>
    </main>
    <van-button style="margin-top: 20px;" round block type="info" @click="$router.push('/login')">
      返回登录
    </van-button>
    <div @click="handle2regist" class="regist">
      继续注册
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orgLists: []
    }
  },
  created() {
    this.verifyId = this.$route.query.verifyId
    this.orgLists = JSON.parse(localStorage.getItem('hasRegistOrgLists'))
  },
  methods: {
    handle2regist() {
      this.$router.push({
        path: '/registChooseOrg',
        query: {
          verifyId: this.verifyId,
          openAccountId: this.orgLists[0].accountId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.registHasOrgs {
  padding: 20px;
  .title {
    color: #909399;
  }
  .org-item {
    display: flex;
    align-items: center;
    margin-top: 20px;
    img {
      width: 48px;
      height: 48px;
      margin-right: 10px;
    }
    div {
      flex: 1;
    }
  }
}
.regist {
  margin-top: 30px;
  text-align: center;
  color: #909399;
  font-size: 16px;
}
</style>
